import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/ar";
import "dayjs/locale/en";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
const CommentItem = ({ comment }) => {
    const { i18n } = useTranslation();
    const locale = i18n.language === "ar" ? "ar" : "en";
    const navigate = useNavigate();

    return (
        <div
            className="flex gap-4 p-4 duration-300 border cursor-pointer bg-bg-light-secondary border-border-light rounded-xl hover:shadow-glow dark:bg-bg-dark-secondary dark:border-border-dark"
            onClick={() => navigate(`/profile/${comment?.User?.code}`)}
        >
            {/* Avatar */}
            <img
                src={comment?.User?.avatar}
                alt={comment?.User?.fullName}
                className="object-cover w-10 h-10 rounded-full"
            />

            {/* Content */}
            <div className="flex-1">
                {/* Header */}
                <div className="flex items-center gap-2 text-sm">
                    <span className="font-semibold text-black dark:text-white">{comment?.User?.fullName}</span>
                    <span className="dark:text-text-muted-dark text-text-muted-light">· {dayjs(comment?.createdAt).locale(locale).fromNow()}</span>
                </div>

                {/* Text */}
                <p className="mt-2 text-sm leading-relaxed text-black dark:text-white">
                    {comment?.text}
                </p>

            </div>
        </div>
    );
};

export default CommentItem;
